import React, { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import { useToast } from "@chakra-ui/react";
import BackLogout from "../component/backLogout";
import Loader from "../component/loader";

function FormPage2() {
  const toast = useToast();
  const context = useContext(FormContext);
  const {
    loginObj,
    setLoginObj,
    stateArr,
    stateList,
    editable,
    backward,
    setEditable,
    reversepage,
    setReversepage,
    disableinput,
    setDisableinput,
    neetdisableinput,
    setNeetDisableinput,
  } = context;
  const navigate = useNavigate();

  const [yearDrop, setYearDrop] = useState([]);
  const [fp2loader, setFP2loader] = useState(false);

  // newadd for blur
  const [phyinputDisabled, setPhyInputDisabled] = useState(false);
  const [chemInputDisable, setChemInputDisable] = useState(false);
  const [enginputDisabled, setengInputDisabled] = useState(false);
  const [bioinputDisabled, setbioInputDisabled] = useState(false);
  const [neetRank, setNeetRank] = useState(false);
  const [neetScoredata, setNeetScoredata] = useState(false);
  const [disableScoreinput, setDisableScoreinput] = useState(true);

  const createarray = (e) => {
    var currentyear = new Date().getFullYear();
    var arrayyer = [];
    for (let i = currentyear; i >= 1970; i--) {
      arrayyer.push(i);
    }

    setYearDrop(arrayyer);
  };

  const handlePositive = (e) => {
    let input = e.target.value;

    const pattern = /^[0-9]*$/;

    if (pattern.test(input)) {
      e.target.value = input;
    } else {
      e.target.value = null;
    }
  };

  const handleSaveFormPage2 = () => {
    loginObj["student_id"] = localStorage.getItem("studentId");
    loginObj["db_name"] = "erp_eshiksa";
    loginObj["stream"] = "Medical";
    loginObj["email"] = localStorage.getItem("email");

    if (loginObj.postalCode.length === 6) {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Cookie", "ci_session=gliuijh4lm0h2rlafbvtgo6r8vj6f9if");
      myHeaders.append("auth_token", localStorage.getItem("token"));

      var raw = JSON.stringify(loginObj);

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch("https://erpapi.eshiksa.net/Gadvasu/SaveData.php", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          var responseObjFS = JSON.parse(result);
          console.log(responseObjFS);
          if (responseObjFS.success === 1) {
            setFP2loader(false);
            toast({
              title: "Alert",
              description: responseObjFS.msg,
              status: "success",
              duration: 1000,
              isClosable: true,
              position: "top",
            });
            navigate("/FormPage3");
          }
        })
        .catch((error) => console.log("error", error));
    } else {
      toast({
        title: "Alert",
        description: "Please fill correct Postal code",
        status: "error",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
    }
  };

  const handleSubmitPage2 = (e) => {
    e.preventDefault();

    console.log(loginObj);
    setFP2loader(true);

    let pcbepercent = loginObj.twlPCBEPercentage;
    let showAppearedMsg = true;

    if (loginObj.resident === "Yes") {
      if (
        loginObj.student_Category !== "General" &&
        loginObj.student_Category !== "Gen/EWS" &&
        loginObj.CourseName === "UG"
      ) {
        if (pcbepercent >= 47.5 && loginObj.NEETstatus === "Appeared") {
          handleSaveFormPage2();
        } else if (pcbepercent <= 47.5) {
          setFP2loader(false);
          showAppearedMsg = false;
          toast({
            title: "Alert",
            description: "Sorry you fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (
        loginObj.student_Category !== "General" &&
        loginObj.student_Category !== "Gen/EWS" &&
        loginObj.CourseName === "Diploma-2 years"
      ) {
        if (pcbepercent >= 40) {
          handleSaveFormPage2();
        } else {
          setFP2loader(false);
          toast({
            title: "Alert",
            description: "Sorry you fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (
        (loginObj.student_Category === "General" ||
          loginObj.student_Category === "Gen/EWS") &&
        loginObj.CourseName === "UG" &&
        loginObj.whetherDisabled === "No"
      ) {
        if (pcbepercent >= 50 && loginObj.NEETstatus === "Appeared") {
          handleSaveFormPage2();
        } else if (pcbepercent < 50) {
          setFP2loader(false);
          showAppearedMsg = false;
          toast({
            title: "Alert",
            description: "Sorry you fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (
        (loginObj.student_Category === "General" ||
          loginObj.student_Category === "Gen/EWS") &&
        loginObj.CourseName === "UG" &&
        loginObj.whetherDisabled === "Yes"
      ) {
        if (pcbepercent >= 47.5 && loginObj.NEETstatus === "Appeared") {
          handleSaveFormPage2();
        } else if (pcbepercent < 47.5) {
          setFP2loader(false);
          showAppearedMsg = false;
          toast({
            title: "Alert",
            description: "Sorry you fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (
        (loginObj.student_Category === "General" ||
          loginObj.student_Category === "Gen/EWS") &&
        loginObj.CourseName === "Diploma-2 years" &&
        loginObj.whetherDisabled === "No"
      ) {
        if (pcbepercent >= 50) {
          handleSaveFormPage2();
        } else {
          setFP2loader(false);

          toast({
            title: "Alert",
            description: "Sorry you fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      } else if (
        (loginObj.student_Category === "General" ||
          loginObj.student_Category === "Gen/EWS") &&
        loginObj.CourseName === "Diploma-2 years" &&
        loginObj.whetherDisabled === "Yes"
      ) {
        if (pcbepercent >= 40) {
          handleSaveFormPage2();
        } else {
          setFP2loader(false);
          toast({
            title: "Alert",
            description: "Sorry you fall below the cuttoff.",
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      }
    } else {
      if (
        pcbepercent >= 50 &&
        loginObj.NEETstatus === "Appeared" &&
        loginObj.CourseName === "UG"
      ) {
        handleSaveFormPage2();
      } else if (
        pcbepercent >= 50 &&
        loginObj.CourseName === "Diploma-2 years"
      ) {
        handleSaveFormPage2();
      } else if (pcbepercent < 50) {
        setFP2loader(false);
        showAppearedMsg = false;
        toast({
          title: "Alert",
          description: "Sorry you fall below the cuttoff.",
          status: "error",
          duration: 1000,
          isClosable: true,
          position: "top",
        });
      }
    }

    if (showAppearedMsg && loginObj.NEETstatus === "Not Appeared") {
      setFP2loader(false);
      toast({
        title: "Alert",
        description: "You Need to appear for NEET 2024.",
        status: "error",
        duration: 1000,
        isClosable: true,
        position: "top",
      });
    }
  };

  useEffect(() => {
    window.onbeforeunload = () => {
      return "";
    };
    window.scrollTo(0, 0);

    stateList();
    createarray();
    // Unmount the window.onbeforeunload event
    return () => {
      window.onbeforeunload = null;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let tenthPercent = (loginObj.tenMarksObt / loginObj.tenMaxMarks) * 100;

    setLoginObj({ ...loginObj, tenMarksPercent: tenthPercent });
    // eslint-disable-next-line
  }, [loginObj.tenMarksObt, loginObj.tenMaxMarks]); // eslint-disable-next-line

  const [totalPCBE, setTotalPCBE] = useState([0, 0]);
  const [totalObtainedPCBE, setTotalObtainedPCBE] = useState([0, 0]);

  useEffect(() => {
    let totalMarksArrayB = Object.values(totalPCBE).map((item) =>
      parseInt(item)
    );
    let TotalB = totalMarksArrayB.reduce((a, b) => a + b);

    setLoginObj({
      ...loginObj,
      twlMaxMarksPCBE: TotalB,
    });

    // eslint-disable-next-line
  }, [totalPCBE]);

  useEffect(() => {
    let totalMarksObtArray = Object.values(totalObtainedPCBE).map((item) =>
      parseInt(item)
    );
    let TotalObt = totalMarksObtArray.reduce((a, b) => a + b);

    setLoginObj({
      ...loginObj,
      twlPCBEMarks: TotalObt,
    });
    // eslint-disable-next-line
  }, [totalObtainedPCBE]); // eslint-disable-next-line

  useEffect(() => {
    let PCBEpercnt = (loginObj.twlPCBEMarks / loginObj.twlMaxMarksPCBE) * 100;

    const roundedPCBE = parseFloat(PCBEpercnt).toFixed(2);

    setLoginObj({
      ...loginObj,
      twlPCBEPercentage: roundedPCBE,
    });
    // eslint-disable-next-line
  }, [loginObj.twlMaxMarksPCBE, loginObj.twlPCBEMarks]);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem("token"));

    var raw = JSON.stringify({
      // Branch_id: "1790",
      Branch_id: "2245",
      student_id: localStorage.getItem("studentId"),
      db_name: "erp_eshiksa",
      email: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);

        if (resultObj.success === 1) {
          setLoginObj(resultObj.form_data);
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line
  }, []);

  const handlepin = (e) => {
    let input = e.target.value;

    const pattern = /^[0-9]*$/;

    if (pattern.test(input)) {
      e.target.value = input.slice(0, 6);
    } else {
      e.target.value = null;
    }
  };

  // setmarks function
  const Reset = () => {
    const updatedLoginObj = {
      ...loginObj,
      twlBMarksObt: "",
      twlPMarksObt: "",
      twlEMarksObt: "",
      twlCMarksObt: "",
      twlPMaxMarks: "",
      twlCMaxMarks: "",
      twlEMaxMarks: "",
      twlBMaxMarks: "",
      twlMaxMarksPCBE: "",
      twlPCBEMarks: "",
      twlPCBEPercentage: "",
    };
    setLoginObj(updatedLoginObj);
    setEditable(true);
    setReversepage(false);
    setPhyInputDisabled(false);
    setChemInputDisable(false);
    setengInputDisabled(false);
    setbioInputDisabled(false);
    setDisableinput(false);
  };

  const SetRank = () => {
    const updateRank = {
      ...loginObj,
      neetRollNo: "",
      NEETAIR: "",
      neetscoreobt: "",
    };
    setLoginObj(updateRank);
    setNeetDisableinput(false);
    setEditable(true);
    setNeetRank(false);
    setReversepage(false);
    setNeetScoredata(false);
  };

  // blurfunction

  const handleBlur = () => {
    if (loginObj.twlPMarksObt !== "") {
      setPhyInputDisabled(true);
    }
  };

  const handlechemBlur = () => {
    if (loginObj.twlCMarksObt !== "") {
      setChemInputDisable(true);
    }
  };

  const handlebio = () => {
    if (loginObj.twlBMarksObt !== "") {
      setbioInputDisabled(true);
    }
  };

  const handleengBlur = () => {
    if (loginObj.twlEMarksObt !== "") {
      setengInputDisabled(true);
    }
  };

  const handleneetBlur = () => {
    if (loginObj.NEETAIR !== "") {
      setNeetRank(true);
    }
  };

  const handleNeetscoreblur = () => {
    if (loginObj.neetscoreobt !== "") {
      setNeetScoredata(true);
    }
  };

  // refreshpage
  useMemo(() => {
    const isRefreshed =
      performance &&
      performance.navigation &&
      performance.navigation.type === performance.navigation.TYPE_RELOAD;
    if (isRefreshed) {
      setReversepage(true);
    }
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div>
          <button
            className="btn btn-sm my-2 "
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
          >
            {" "}
            <i className="fa-solid fa-user mx-2"> </i>
            {loginObj.name}
          </button>
          <BackLogout />
        </div>

        <form onSubmit={(e) => handleSubmitPage2(e)}>
          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Address Details</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Address Line 1*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address Line 1"
                  name="addLine1"
                  value={loginObj.addLine1}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Address Line 2</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Address Line 2"
                  name="addLine2"
                  value={loginObj.addLine2}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">City*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="City"
                  name="city"
                  value={loginObj.city}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Country*</label>
                <select
                  className="form-select"
                  name="country"
                  value={loginObj.country}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="India">India</option>
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">State/Province*</label>
                <select
                  name="stateNameAdd"
                  value={loginObj.stateNameAdd}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {stateArr.map((item, i) => {
                    return (
                      <option key={i} value={item.state_name}>
                        {item.state_name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Postal code*</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Postal Code"
                  name="postalCode"
                  value={loginObj.postalCode}
                  onKeyUp={handlepin}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
            </div>
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Educational Information- 10th</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Name of the School- 10th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of the School- 10th"
                  name="tenSchoolName"
                  value={loginObj.tenSchoolName}
                  onChange={(e) => {
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    });
                    createarray(e);
                  }}
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Board- 10th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Board- 10th"
                  name="tenSchoolBoard"
                  value={loginObj.tenSchoolBoard}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Year of Passing - 10th*</label>
                <select
                  name="tenPassYear"
                  value={loginObj.tenPassYear}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {yearDrop.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Percentage - 10th *</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Percentage - 10th"
                  name="tenMarksPercent"
                  value={loginObj.tenMarksPercent}
                  // onKeyUp={(e) => handlePositive(e)}
                  onChange={(e) => {
                    if (e.target.value <= 100) {
                      let input = e.target.value;
                      e.target.value =
                        input.indexOf(".") > 0
                          ? input.split(".").length >= 2
                            ? input.split(".")[0] +
                              "." +
                              input.split(".")[1].substring(-1, 2)
                            : input
                          : input;
                      setLoginObj({
                        ...loginObj,
                        [e.target.name]: e.target.value,
                      });
                    } else {
                      e.target.value = 0;
                    }
                  }}
                  required
                />
              </div>
            </div>
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Educational Information- 12th</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">
                  Name of the Institute- 12th*
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of the School- 12th"
                  name="twlSchoolName"
                  value={loginObj.twlSchoolName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Board- 12th*</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Board- 12th"
                  name="twlBoardName"
                  value={loginObj.twlBoardName}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Year of Passing - 12th*</label>
                <select
                  name="twlPassYear"
                  value={loginObj.twlPassYear}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  {yearDrop.map((item, i) => {
                    return (
                      <option key={i} value={item}>
                        {item}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-sm-12 col-lg-3">
                <label className="form-label">Exam Status-12th*</label>
                <select
                  name="twlExamStatus"
                  value={loginObj.twlExamStatus}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                  required
                  className="form-select"
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="Passed">Passed</option>
                </select>
              </div>
            </div>

            <div className="row justify-content-end p-4">
              <button
                type="reset"
                className="btn btn-primary col-md-2
              "
                onClick={Reset}
              >
                Set Marks
              </button>
            </div>

            <div className="row p-3 mx-auto">
              <table className="table tabWidth mx-auto border ">
                <thead>
                  <tr className="text-center">
                    <th scope="col-2">Subject</th>
                    <th scope="col">Max. Marks</th>
                    <th scope="col">Marks Obtained</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      Physics{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Physics Max Marks"
                        name="twlPMaxMarks"
                        onKeyUp={(e) => handlePositive(e)}
                        value={loginObj.twlPMaxMarks}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        disabled={
                          loginObj.twlPMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Physics Marks Obtained"
                        name="twlPMarksObt"
                        maxLength={loginObj.twlPMaxMarks}
                        value={loginObj.twlPMarksObt}
                        onKeyUp={(e) => {
                          if (e.target.value > e.target.maxLength) {
                            e.target.value = null;
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const phymarks = loginObj.twlPMaxMarks;
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= phymarks
                          ) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handleBlur}
                        // disabled={
                        //   phyinputDisabled ||
                        //   (!editable && !backward) ||
                        //   reversepage
                        // }
                        disabled={
                          phyinputDisabled ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      Chemistry{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Chemistry Max Marks"
                        name="twlCMaxMarks"
                        onKeyUp={(e) => handlePositive(e)}
                        value={loginObj.twlCMaxMarks}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        disabled={
                          loginObj.twlCMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Chemistry Marks Obtained"
                        name="twlCMarksObt"
                        maxLength={loginObj.twlCMaxMarks}
                        max={loginObj.twlCMaxMarks}
                        value={loginObj.twlCMarksObt}
                        onKeyUp={(e) => {
                          if (e.target.value > e.target.maxLength) {
                            e.target.value = null;
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const maxMarks = parseInt(
                            e.target.getAttribute("max")
                          );
                          if (!isNaN(inputValue) && inputValue <= maxMarks) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handlechemBlur}
                        // disabled={
                        //   chemInputDisable ||
                        //   (!editable && !backward) ||
                        //   reversepage
                        // }
                        disabled={
                          chemInputDisable ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      English{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="English Max Marks"
                        name="twlEMaxMarks"
                        onKeyUp={(e) => handlePositive(e)}
                        value={loginObj.twlEMaxMarks}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        disabled={
                          loginObj.twlEMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="English Marks Obtained"
                        name="twlEMarksObt"
                        maxLength={loginObj.twlEMaxMarks}
                        value={loginObj.twlEMarksObt}
                        onKeyUp={(e) => {
                          if (e.target.value > e.target.maxLength) {
                            e.target.value = null;
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const engMarks = loginObj.twlEMaxMarks;
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= engMarks
                          ) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handleengBlur}
                        disabled={
                          enginputDisabled ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="fw-bold w-25 mx-auto text-center pt-3">
                      {" "}
                      Biology{" "}
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Biology Max Marks"
                        name="twlBMaxMarks"
                        onKeyUp={(e) => handlePositive(e)}
                        value={loginObj.twlBMaxMarks}
                        onChange={(e) => {
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          });
                          setTotalPCBE({
                            ...totalPCBE,
                            [e.target.name]: e.target.value,
                          });
                        }}
                        disabled={
                          loginObj.twlBMarksObt !== "" ||
                          (!editable && !backward)
                        }
                        required
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-control w-75 mx-auto number-input"
                        placeholder="Biology Marks Obtained"
                        name="twlBMarksObt"
                        maxLength={loginObj.twlBMaxMarks}
                        value={loginObj.twlBMarksObt}
                        onKeyUp={(e) => {
                          if (e.target.value > e.target.maxLength) {
                            e.target.value = null;
                          }
                          handlePositive(e);
                        }}
                        onChange={(e) => {
                          const inputValue = parseInt(e.target.value);
                          const biomarks = loginObj.twlBMaxMarks;
                          if (
                            !isNaN(inputValue) &&
                            inputValue >= 0 &&
                            inputValue <= biomarks
                          ) {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: inputValue,
                            });
                            setTotalObtainedPCBE({
                              ...totalObtainedPCBE,
                              [e.target.name]: inputValue,
                            });
                          } else {
                            toast({
                              title: "Alert",
                              description: "Check marks obtained or note below",
                              status: "error",
                              duration: 1000,
                              isClosable: true,
                              position: "top",
                            });
                          }
                        }}
                        onBlur={handlebio}
                        disabled={
                          bioinputDisabled ||
                          (!editable && !backward) ||
                          reversepage ||
                          disableinput
                        }
                        required
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Max. Marks (PCBE)</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Maximum Marks"
                  name="twlMaxMarksPCBE"
                  value={loginObj.twlMaxMarksPCBE}
                  readOnly
                  required
                />
              </div>

              <div className="col-sm-12 col-lg-4">
                <label className="form-label">
                  Total Marks Obtained (PCBE)
                </label>
                <input
                  type="number"
                  className="form-control number-input"
                  name="twlPCBEMarks"
                  value={loginObj.twlPCBEMarks}
                  readOnly
                  required
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Percentage in (PCBE)*</label>
                <input
                  type="number"
                  className="form-control number-input"
                  placeholder="Percentage"
                  name="twlPCBEPercentage"
                  value={loginObj.twlPCBEPercentage}
                  readOnly
                  required
                />
              </div>
            </div>
          </div>

          {loginObj.CourseName === "UG" && (
            <>
              <div className="row border border-3 rounded-3 my-3">
                <div className="p-0">
                  <div className="w-100 p-1 pt-2 px-3 form_input_header">
                    <h6 className="text-light">
                      Neet - U.G. - 2024 Information{" "}
                    </h6>
                  </div>
                </div>

                <div className="row p-3">
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">NEET Status</label>
                    <select
                      name="NEETstatus"
                      className="form-select"
                      value={loginObj.NEETstatus}
                      onChange={(e) => {
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      required
                    >
                      <option value="" selected>
                        Select
                      </option>
                      <option value="Appeared">Appeared</option>
                      <option value="Not Appeared">Not Appeared</option>
                    </select>
                  </div>
                  {loginObj.NEETstatus === "Appeared" && (
                    <>
                      <div className="col-sm-12 col-lg-4">
                        <label className="form-label">NEET Roll No.</label>
                        <input
                          type="number"
                          className="form-control number-input"
                          placeholder="NEET Roll No"
                          name="neetRollNo"
                          value={loginObj.neetRollNo}
                          onChange={(e) => {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: e.target.value,
                            });
                          }}
                          disabled={
                            loginObj.NEETAIR !== "" || (!editable && !backward)
                          }
                          required
                        />
                      </div>

                      <div className="col-sm-12 col-lg-4">
                        <label className="form-label">
                          NEET All India Rank
                        </label>
                        <input
                          type="number"
                          className="form-control number-input"
                          placeholder="NEET All India Rank"
                          name="NEETAIR"
                          value={loginObj.NEETAIR}
                          onChange={(e) => {
                            setLoginObj({
                              ...loginObj,
                              [e.target.name]: e.target.value,
                            });
                          }}
                          onBlur={handleneetBlur}
                          disabled={
                            neetRank ||
                            (!editable && !backward) ||
                            reversepage ||
                            neetdisableinput
                          }
                          required
                        />
                      </div>

                      <div className="col-sm-12 col-lg-4">
                        <label className="form-label">
                          Neet Score Obtained
                        </label>
                        <input
                          type="number"
                          className="form-control number-input"
                          placeholder="Neet Score Obtained"
                          name="neetscoreobt"
                          value={loginObj.neetscoreobt}
                          onChange={(e) => {
                            const inputValue = parseInt(e.target.value);
                            const nscoreobt = "720";
                            if (!isNaN(inputValue) && inputValue <= nscoreobt) {
                              setLoginObj({
                                ...loginObj,
                                [e.target.name]: inputValue,
                              });
                            } else {
                              toast({
                                title: "Alert",
                                description:
                                  "Check marks obtained or note below",
                                status: "error",
                                duration: 1000,
                                isClosable: true,
                                position: "top",
                              });
                            }
                          }}
                          // onChange={(e) => {
                          //   setLoginObj({
                          //     ...loginObj,
                          //     [e.target.name]: e.target.value,
                          //   });
                          // }}
                          onBlur={handleNeetscoreblur}
                          disabled={
                            neetScoredata ||
                            (!editable && !backward) ||
                            reversepage ||
                            neetdisableinput
                          }
                          required
                        />
                      </div>

                      <div className="col-md-3  pt-2">
                        <label className="form-label"></label>
                        <button
                          type="button"
                          className="btn btn-primary w-100 mt-4"
                          onClick={SetRank}
                        >
                          Set Rank
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </>
          )}

          <div className="row justify-content-around my-5">
            <div style={{ color: "#ed0909" }}>
              <label>Note:-</label>
              <h6>
                Please click on "Set Marks" button for entering or editing the
                marks.
              </h6>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-25"
              disabled={
                fp2loader ||
                !loginObj.twlBMarksObt ||
                !loginObj.twlEMarksObt ||
                !loginObj.twlCMarksObt ||
                !loginObj.twlPMarksObt
              }
            >
              Submit
              {fp2loader && <Loader />}
            </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default FormPage2;
